import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AppLocalStorage } from '../../../app-storage-manager/local-storage';
import { Store } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { logout } from '../_state/auth.actions';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor( private toastr: ToastrService, private storeManager: AppLocalStorage, private store: Store<AppState>) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.storeManager.getAccessToken();
        if (token) {
            const clonedReq = req.clone({
                headers : req.headers.set('Authorization', `Bearer ${token}`)
            })
            return next.handle(clonedReq).pipe(
                catchError((error: HttpErrorResponse) => {
                    if (
                        (
                            error.error.errors === 'Token is not valid'
                            ) || (error.status === 401)) {
                                this.toastr.info('Login to continue', 'Your session has expired and you have been logged out');
                                this.store.dispatch(logout());
                                return of({}) as Observable<HttpEvent<any>>;
                            }
                            return  throwError(error);
                })
              );
        } else {
            return next.handle(req).pipe(
                catchError((error: HttpErrorResponse) => {
                    if (
                        (
                            error?.error?.errors === 'Token is not valid'
                            ) || (error?.status === 401)) {
                                this.toastr.info('Login to continue', 'Your session has expired and you have been logged out');
                                this.store.dispatch(logout());
                                return of({}) as Observable<HttpEvent<any>>;
                            }
                            return  throwError(error);
                })
              );
        }
    }
}